import React from "react";
import { ENUM_FORM_DISPLAY, ENUM_FORM_LAYOUT_CONTAINER } from "./pageList";
import { useFormRender } from "../hooks/useFormRender";
import { Button, Text, Select, Textarea, Switch } from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import { IconSettings } from "@tabler/icons";
import DateOffPicker from "./dateOffPicker";
import { useServerApi } from "../hooks/userServerApi";
import { DATA_POLICY_DELIVER_METHODS } from "../data/options";
import { showNotification } from "@mantine/notifications";
import { IconCheck } from "@tabler/icons";
import OrderPolicyNumberInput from "./orderPolicyNumberInput";

const OrderConfirmPolicyButton = ({ mainForm, label = "Confirm Policy" }) => {
  const [api] = useServerApi();
  const formSchema = {
    title: "Confirm Policy",
    description: "Please follow the step to print the cover sheet",

    display: {
      mode: ENUM_FORM_DISPLAY.MODAL,
      size: "xl", //xs, sm, xl  ....100%
    },
    showSaveBar: true,
    closeAfterSave: true,

    initialValues: {
      policyDeliverMethod: "Electronic",
    },

    layout: {
      containers: [
        {
          key: "section-confirm",
          parent: null,
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            // title: "Confirm Policy",
            description:
              "Please enter the form to complete the policy confirmation",
            withBorder: false,
            mt: 0,
            ml: 20,
          },
        },
        {
          key: "grid",
          parent: "section-confirm",
          type: ENUM_FORM_LAYOUT_CONTAINER.GRID,
          cols: [
            {
              key: "g1",
              props: {
                span: 6,
                mt: 0,
              },
            },
            {
              key: "g2",
              props: {
                span: 6,
                mt: 0,
              },
            },
          ],
        },
      ],

      fields: [
        {
          name: "policyNumber",
          component: OrderPolicyNumberInput,
          parent: "g1",
          props: {},
        },

        {
          name: "policyCommenceDate",
          component: DatePicker,
          type: "datePicker",
          parent: "g1",
          props: {
            required: true,
            label: "Policy Commence Date",
            zIndex: 1000,
            placeholder: "Pick Date",
            allowFreeInput: true,
          },
        },
        {
          name: "policyIssueDate",
          component: DatePicker,
          type: "datePicker",
          parent: "g1",
          props: {
            required: true,
            label: "Policy Issue Date",
            zIndex: 1000,
            placeholder: "Pick Date",
            allowFreeInput: true,
          },
        },
        {
          name: "policyAckSignDate",
          component: DateOffPicker,
          type: "datePicker",
          parent: "g1",
          props: {
            required: true,
            relatedField: "policyIssueDate",
            daysOff: 9,
            editable: true,
            label: "Policy Acknowledge Date",
            zIndex: 1000,
            placeholder: "Pick Date",
            allowFreeInput: true,
          },
        },

        {
          name: "policyCoolingOffDate",
          component: DateOffPicker,
          type: "datePicker",
          parent: "g2",
          props: {
            required: true,
            relatedField: "policyAckSignDate",
            daysOff: 21,
            label: "Cooling Off Expire Date",
            zIndex: 1000,
            placeholder: "Pick Date",
            allowFreeInput: true,
          },
        },

        {
          name: "policyRemark",
          component: Textarea,
          parent: "g2",
          props: {
            label: "Remark",
            minRows: 4,
          },
        },
        {
          name: "dateBackOption",
          component: Switch,
          parent: "g2",
          props: {
            type: "checkbox",
            label: "Date Back Option",
            size: "xs",
          },
        },
        {
          name: "premiumFinancing",
          component: Switch,
          parent: "g2",
          props: {
            type: "checkbox",
            label: "Premium Financing",
            size: "xs",
          },
        },
        {
          name: "policyReplacement",
          component: Switch,
          parent: "g2",
          props: {
            type: "checkbox",
            label: "Policy Replacement",
            size: "xs",
          },
        },
      ],
    },
  };

  const onSubmit = async ({ values, formMode }) => {
    // console.log("onSubmit", values._id);
    try {
      mainForm.setValues(values);
      const saved = await mainForm.saveValues(values);
      if (saved?.success === false) {
        return { handled: true, success: false };
      }

      let result = await api.Order.confirmPolicy(values._id);
      if (!result || !result.order) {
        return { handled: true, success: false };
      }

      // console.log("order status", result);
      mainForm.setFieldValue("status", result.order.status);
      mainForm.setFieldValue("riders", result.order.riders);
      mainForm.notifyListRefresh?.();

      formAction.close();

      showNotification({
        title: `Order ${result?.order?.code} Confirmed Successfully.`,
        icon: <IconCheck size={18} />,
        message: "Data Saved",
      });
      return { handled: true, success: true };
    } catch (error) {
      console.log(error);
      return { handled: true, success: false };
    }
  };

  const [renderForm, formAction, formStatus, formSetting] = useFormRender(
    formSchema,
    null,
    onSubmit
  );

  const handleActionClick = () => {
    const id = mainForm?.values._id;
    // console.log('%corderPrintCoverSheetActionButton.js line:86 object', 'color: #007acc;', id);
    if (!id) return;
    formAction.open({ mode: "edit", id, data: mainForm.values });
  };

  return (
    <>
      <Button fullWidth onClick={handleActionClick}>
        {label}
      </Button>

      {renderForm()}
    </>
  );
};

export default OrderConfirmPolicyButton;
